<template>
  <div>
    <es-exception v-if="!hasModule('SYS:SEC:USRMGR:VIEW')"
      exceptionMessage="Sorry, you are not authorized to access this content."
    />
    <es-loader v-else-if="loadingPage" style="margin: 2rem"/>
    <es-exception v-else-if="!loadingPage && loadingError" style="padding: 6.5rem" margin="0rem"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <div>
        <template>
          <div>
            <es-profile-header>
              <template #profile-header>
                <div class="header-title">
                  {{userMaster.firstName}} {{userMaster.lastName}}
                </div>
                <div class="header-subtitle">
                  <font-awesome-icon :icon="['fas', 'envelope']" size="1x" title="Email"/>
                  {{userMaster.email}}
                </div>
                <div class="header-subtitle" v-if="userMaster.phone1!==''">
                  <font-awesome-icon :icon="['fas', 'phone']" title="Phone Number"/>
                  {{maskPhone(userMaster.phone1)}}
                </div>
              </template>
              <template #profile-overview>
                <div class="columns">
                  <div class="column">
                    <div class="column-content">
                      <div class="column-title">{{userMaster.status}}</div>
                      <div class="column-subtitle">Status</div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="column-content">
                      <div class="column-title">
                        {{userMaster.lastAccessedDate | formatDateMMDDYYYY }}
                      </div>
                      <div class="column-subtitle">Last Login</div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="column-content">
                      <div class="column-title">
                        {{userMaster.lastUpdateDate | formatDateMMDDYYYY }}
                      </div>
                      <div class="column-subtitle">Last Updated</div>
                    </div>
                  </div>
                </div>
              </template>
            </es-profile-header>
          </div>
        </template>
        <div v-if="user" class="document-container"
        :class="{'edit-mode':isEditGeneral}">
        <div v-if= "showModal">
          <user-remove-authorization-modal
          v-for="(locationPermission,index) in locationPermissions"
          :key="index"
          :locationPermission = "locationPermission"
          :roleId = "roleId"
          :userId = "id"
          @closeModal= "toggleModal"
          @reloadAuthorizationPanel = "reloadAuthorizationPanel('delete')"
          />
        </div>
        <div class="document">
          <div class="header">
            <es-header>
              <template #header>
                <div class="header-title">General</div>
                <div class="header-subtitle">
                  View/edit general profile information.
                </div>
              </template>
              <template #actions>
                <ul>
                  <li class="p-narrow no-border">
                    <div v-if="hasModule('SYS:SEC:USRMGR:EDIT')" class="list-content">
                      <a :class="{disabled: currentEditPanel != ''
                          && currentEditPanel != 'general'}"
                        :tabindex="currentEditPanel !=''
                          && currentEditPanel != 'general'? -1 : 0"
                        role="button"
                        @click="editPanel('general')"
                        @keypress.enter.prevent="editPanel('general')"
                        v-if="!isEditGeneral"
                      >
                      <font-awesome-icon :icon="['fas', 'edit']" size="lg" title="Edit" />
                      </a>
                    </div>
                  </li>
                </ul>
              </template>
            </es-header>
          </div>
          <div class="content">
            <es-form>
              <template #es-form-header>
                <div class="header-container">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'user']" size="lg" />
                  </div>
                  <div class="header-elements">
                    <h6 class="title">
                      Person Information
                    </h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="fName">First Name</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input"
                          :class="{ 'is-static': !isEditGeneral,
                          'is-danger' : hasErrorFirstName}"
                          type="text"
                          v-model="user.firstName"
                          :readonly="!isEditGeneral"
                          @keyup.prevent="validateField('firstName')"
                          id="fName">
                        </div>
                        <span v-if="hasErrorFirstName" class="help is-danger">
                          {{ msgFirstName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="mName">Middle Name
                        <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input" :class="{ 'is-static': !isEditGeneral,
                          'is-danger' : hasErrorMiddleName }"
                          type="text"
                          v-model="user.middleName"
                          :readonly="!isEditGeneral"
                          @keyup.prevent="validateField('middleName')"
                          id="mName">
                        </div>
                        <span v-if="hasErrorMiddleName" class="help is-danger">
                          {{ msgMiddleName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="lName">Last Name</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input" :class="{ 'is-static': !isEditGeneral,
                          'is-danger' : hasErrorLastName }"
                          type="text"
                          v-model="user.lastName"
                          :readonly="!isEditGeneral"
                          @keyup.prevent="validateField('lastName')"
                          id="lName">
                        </div>
                        <span v-if="hasErrorLastName" class="help is-danger">
                          {{ msgLastName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="dobID">Date Of Birth
                        <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input type="text"
                          class="input"
                          :class="{ 'is-static': !isEditGeneral }"
                          readonly
                          :value="dateOfBirthYYYYMMDD | formatDateMMDDYYYY"
                          v-if="!isEditGeneral && dateOfBirthYYYYMMDD !== ''"
                          id="dobID"/>
                          <input
                          class="input calendar is-half-width"
                          :class="{ 'is-danger' : hasErrorDateOfBirth }"
                          type="date"
                          v-model="dateOfBirthYYYYMMDD"
                          v-if="isEditGeneral"
                          @change.prevent="checkFormat('dateOfBirth')"
                          id="dobID"/>
                        </div>
                        <span v-if="hasErrorDateOfBirth" class="help is-danger">
                          {{ msgDateOfBirth }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="gLabel">Gender</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            type="text"
                            class="input" :class="{ 'is-static': !isEditGeneral }"
                            readonly
                            v-model="user.gender.description"
                            v-if="!isEditGeneral"
                            id="gLabel"/>
                          <div v-if="isEditGeneral">
                            <div class="buttons has-addons">
                              <button
                              v-for="(item, index) in activeGenders"
                              :key="index"
                              class="button button--form"
                              @click.prevent="user.gender.code=item.code; validateField('gender')"
                              :class="{
                                'is-active': user.gender.code === item.code}"
                                style="min-width: 100px">
                                {{ item.description }}
                              </button>
                            </div>
                        </div>
                      </div>
                      <span v-if="hasErrorGender" class="help is-danger">
                        {{ msgGender }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="emailLabel">Email</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input type="text"
                        class="input is-static"
                        :class="{'is-readonly' : isEditGeneral}"
                        readonly
                        v-model="user.email"
                        id="emailLabel"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="phone1">Phone 1
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input"
                        :class="{'is-danger' : hasErrorPhone1}"
                        type="text"
                        v-model.lazy="user.phone1"
                        @change="checkFormat('phone1')"
                        v-if="isEditGeneral"
                        id="phone1">
                        <input class="input is-static"
                        type="text"
                        :value="maskPhone(user.phone1)"
                        readonly
                        id="phone1"
                        v-else>
                      </div>
                      <span v-if="hasErrorPhone1" class="help is-danger">
                        {{ msgPhone1 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="phone2">Phone 2
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input"
                        :class="{'is-danger' : hasErrorPhone2}"
                        type="text"
                        v-model.lazy="user.phone2"
                        @change="checkFormat('phone2')"
                        v-if="isEditGeneral"
                        id="phone2"
                        >
                        <input class="input is-static"
                        type="text"
                        :value="maskPhone(user.phone2)"
                        readonly
                        id="phone2"
                        v-else>
                      </div>
                      <span v-if="hasErrorPhone2" class="help is-danger">
                        {{ msgPhone2 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="titleLabel">Title
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input v-if="!isEditGeneral && user.jobClassification"
                          class="input"
                          :class="{ 'is-static': !isEditGeneral }"
                          type="text"
                          :value="user.jobClassification.description"
                          readonly
                          id="titleLabel"
                        />
                        <div v-if="isEditGeneral"
                        class="select is-half-width display-block">
                        <select
                          class="input is-full-width"
                          v-model="user.jobClassification.code"
                          id="titleLabel">
                          <option value=""></option>
                          <option v-for="title in activeTitles"
                            :value="title.code"
                            v-bind:key="title.code">
                            {{ title.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-form>
        <es-form>
          <template #es-form-header>
            <div class="header-container">
              <div class="header-elements">
                <font-awesome-icon :icon="['fas', 'map-marked-alt']" size="lg"/>
              </div>
              <div class="header-elements">
                <h6 class="title">
                  Address
                </h6>
              </div>
            </div>
          </template>
          <template #es-form>
          <div class="row" :class="{ removeUnderline: isEditGeneral }">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label" for="address1Label">Address 1
                  <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span></label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input"
                      :class="{ 'is-static': !isEditGeneral,
                      'is-danger' : hasErrorStreet1 }"
                      type="text"
                      v-model="user.street1"
                      :readonly="!isEditGeneral"
                      @keyup.prevent="validateField('street1')"
                      id="address1Label"/>
                    </div>
                    <span v-if="hasErrorStreet1" class="help is-danger">
                      {{ msgStreet1 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" :class="{ removeUnderline: isEditGeneral }">
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label" for="address2Label">Address 2
                    <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                  </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input" :class="{ 'is-static': !isEditGeneral,
                        'is-danger' : hasErrorStreet2 }"
                        type="text"
                        v-model="user.street2"
                        :readonly="!isEditGeneral"
                        @keyup.prevent="validateField('street2')"
                        id="address2Label"/>
                      </div>
                      <span v-if="hasErrorStreet2" class="help is-danger">
                        {{ msgStreet2 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="cityLabel">City
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional) </span>
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input" :class="{ 'is-static': !isEditGeneral,
                        'is-danger' : hasErrorCity }"
                        type="text"
                        v-model="user.city"
                        :readonly="!isEditGeneral"
                        @keyup.prevent="validateField('city')"
                        id="cityLabel">
                      </div>
                      <span v-if="hasErrorCity" class="help is-danger">
                        {{ msgCity }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="stateLabel">State
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                    </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input v-if="!isEditGeneral && user.state"
                            class="input"
                            :class="{ 'is-static': !isEditGeneral }"
                            type="text"
                            :value="user.state.description"
                            readonly
                            id="stateLabel"
                          />
                          <div v-if="isEditGeneral"
                          class="select is-half-width display-block">
                          <select
                            class="input is-full-width"
                            v-model="user.state.code"
                            id="stateLabel">
                            <option value=""></option>
                            <option v-for="state in activeStates"
                              :value="state.code"
                              v-bind:key="state.code">
                                {{ state.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="zipLabel">Zip
                      <span class="has-text-grey-light" v-if= "isEditGeneral"> (optional)</span>
                    </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input"
                          :class="{'is-danger' : hasErrorZip}"
                          type="text"
                          v-model.lazy="user.zip"
                          @change="checkFormat('zip')"
                          v-if="isEditGeneral"
                          id="zipLabel">
                          <input class="input is-static"
                          type="text"
                          :value="maskZip(user.zip)"
                          readonly
                          id="zipLabel"
                          v-else>
                        </div>
                        <span v-if="hasErrorZip" class="help is-danger">
                          {{ msgZip }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </es-form>
            <es-form>
              <template #es-form-header>
                <div class="header-container">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'map-marked-alt']" size="lg"/>
                  </div>
                  <div class="header-elements">
                    <h6 class="title">
                      More
                    </h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="statusLabel">Status</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div v-if="isEditGeneral && adminMode && user.status !== 'PENDING'"
                        class="control">
                        <label class="radio" for="activeLabel">
                          <input
                          type="radio"
                          v-model="user.status"
                          value="ACTIVE"
                          id="activeLabel"/>
                          Active
                        </label>
                        <label class="radio" for="inactiveLabel">
                          <input
                          type="radio"
                          v-model="user.status"
                          value="INACTIVE"
                          id="inactiveLabel"/>
                          Inactive
                        </label>
                      </div>
                      <div v-else-if="isEditGeneral && adminMode && user.status === 'PENDING'"
                      class="control">
                        <input class="input is-static"
                        :value="user.status"
                        id="statusLabel"
                        readonly/>
                      </div>
                      <div class="control" v-else>
                        <input type="text"
                        class="input"
                        :class="{'is-static' : !isEditGeneral || !adminMode }"
                        :value="user.status"
                        id="statusLabel"
                        readonly/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: isEditGeneral }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="lastUpdLabel">Last Updated</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input type="text"
                        class="input is-static"
                        :class="{'is-readonly' : isEditGeneral}"
                        readonly
                        :value="user.lastUpdateDate | formatDateMMDDYYYY"
                        id="lastUpdLabel"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
        </div>
        <div class="es-actions" v-if="isEditGeneral">
          <es-form-actions>
            <template #form-actions>
              <div class="bottom-content">
                <ul>
                  <li>
                    <div class="list-content">
                      <a tabindex="0" role="button"
                        @click.prevent="clearAll('general')"
                        @keypress.enter.prevent="clearAll('general')"
                      >
                        Cancel
                      </a>
                    </div>
                  </li>
                  <li>
                    <div class="list-content">
                      <button
                      class="button is-primary"
                      @click.prevent="verifyForm('general')">
                      Update
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </es-form-actions>
        </div>
      </div>
    </div>
    <div v-if="user" class="document-container">
      <div class="document">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title">Authorization Information</div>
            </template>
          </es-header>
        </div>
        <div class="content">
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'user-friends']" size="lg" />
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Person Type Information
                  </h6>
                </div>
                <div class="header-actions">
                    <div v-if="hasModule('SYS:SEC:USRMGR:EDIT')
                    && adminMode" class="list-content">
                      <a :class="{disabled: currentEditPanel != ''
                          && currentEditPanel != 'persontypes' || isCurrentUser }"
                        :tabindex="currentEditPanel !=''
                          && currentEditPanel != 'persontypes'? -1 : 0"
                        role="button"
                        @click="editPanel('persontypes')"
                        @keypress.enter="editPanel('persontypes')"
                        v-if="!isEditPersonTypes"
                      >
                      <font-awesome-icon :icon="['fas', 'edit']" size="lg" title="Edit" />
                      </a>
                    </div>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row no-bottom-border" :class="{ removeUnderline: isEditAuthorization }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" for="pTypesLabel">Person Type(s)</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <span class="tags" v-if="!isEditPersonTypes" >
                          <strong class="tag"
                            v-for="(item, index) in user.userPersonTypes"
                            :key="index">
                              {{ item.personType.name }}
                          </strong>
                        </span>
                        <div v-if="isEditPersonTypes">
                          <es-select
                            :class="{ 'is-danger': hasErrorPersonType }"
                            v-bind:multi="true"
                            v-on:update:values="user.userPersonTypes = $event
                              .map(p=> ({personTypeCode: p.code,userId: user.id}))"
                            ref="selPersonTypes"
                            valueTpl="${name}"
                            :preSelected="selectedPersonTypes"
                            :setValues="userPersonTypes"
                            keyValue="code"
                            v-bind:clearOut="false"
                            controlId="pTypesLabel"
                          />
                        </div>
                      </div>
                      <span v-if="hasErrorPersonType" class="help is-danger">
                        {{ msgPersonType }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <div class="es-actions" v-if="isEditPersonTypes">
            <es-form-actions>
              <template #form-actions>
                <div class="bottom-content">
                  <ul>
                    <li>
                      <div class="list-content">
                        <a tabindex="0" role="button"
                          @click.prevent="clearAll('persontypes')"
                          @keypress.enter.prevent="clearAll('persontypes')"
                        >
                          Cancel
                        </a>
                      </div>
                    </li>
                    <li>
                      <div class="list-content">
                        <button
                        class="button is-primary"
                        @click.prevent="verifyForm('persontypes')">
                        Update
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </es-form-actions>
          </div>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'door-open']" size="lg" />
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Role Information
                  </h6>
                </div>
                <div class="header-actions">
                    <div v-if="hasModule('SYS:SEC:USRMGR:EDIT')
                    && adminMode" class="list-content">
                      <a :class="{disabled: currentEditPanel != ''
                        && currentEditPanel != 'addAuthorization' || isCurrentUser}"
                      :tabindex="currentEditPanel !=''
                          && currentEditPanel != 'addAuthorization'? -1 : 0"
                      role="button"
                      @click="editPanel('addAuthorization')"
                      @keypress.enter="editPanel('addAuthorization')"
                      v-if="!isAddAuthorization">
                      <font-awesome-icon :icon="['fas', 'plus']" size="lg" title="Add"/>
                      </a>
                    </div>
                </div>
              </div>
            </template>
            <template #es-form>
              <div v-if = "loading === false">
                <user-edit-authorization
                v-for="(locationPermission,index) in locationPermissions"
                :key="index"
                :locationPermission = "locationPermission"
                :userId = "id"
                :isStateUser ="isStateUser"
                :currentEditPanel = "currentEditPanel"
                :isEditAuthorization = "isEditAuthorization"
                :adminMode = "adminMode"
                :roles = "roles"
                :primaryRole = "primaryRole"
                :isCurrentUser = "isCurrentUser"
                @reloadAuthorizationPanel = "reloadAuthorizationPanel('edit')"
                :filterProgramsByPersonType="filterProgramsByPersonType"
                @openModal = "toggleModal"
                @editPanel ="editPanel"
                @clearAll = "clearAll"
                />
              </div>
              <user-add-authorization
              :isAddAuthorization = 'isAddAuthorization'
              @reloadAuthorizationPanel = "reloadAuthorizationPanel('add')"
              :isStateUser ="isStateUser"
              :filterProgramsByPersonType="filterProgramsByPersonType"
              @clearAll ="clearAll"
              :roles = "roles"
              :userId ="id"
              />
            </template>
          </es-form>
        </div>
      </div>
    </div>
    <div v-if="this.user" class="document-container"
    :class="{'edit-mode':isEditSecurity}">
    <div class="document">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title">Security</div>
            <div class="header-subtitle">
              View login and reset password.
            </div>
          </template>
          <template #actions>
            <div class="ul-container" v-if="adminMode">
              <ul>
                <li class="p-narrow no-border">
                  <div class="list-content">
                    <a class="edit-link" v-if="hasModule('SYS:SEC:USRMGR:RESETPWD')"
                      @click.prevent='resetPassword(`${user.id}`)'
                      role="button"
                      tabindex="0"
                      @keypress.enter.prevent='resetPassword(`${user.id}`)'>
                      Reset Password
                    </a>
                  </div>
                </li>
              </ul>
              </div>
                <div class="ul-container" v-if="securityMode">
                  <ul>
                    <li class="icon p-narrow no-border">
                      <a :class="{disabled: currentEditPanel != ''
                        && currentEditPanel != 'security'}"
                        :tabindex="currentEditPanel !=''
                          && currentEditPanel != 'security'? -1 : 0"
                        role="button"
                        @click="editPanel('security')"
                        @keypress.enter.prevent="editPanel('security')"
                        v-if="!isEditSecurity && hasModule('SYS:SEC:USRMGR:RESETPWD')"
                      >
                        <font-awesome-icon :icon="['fas', 'edit']" size="lg" title="Edit"/>
                      </a>
                    </li>
                  </ul>
                </div>
              </template>
            </es-header>
          </div>
          <div class="content">
            <es-form v-if="!isEditSecurity">
              <template #es-form-header>
                <div class="header-container">
                  <div class="header-elements">
                    <font-awesome-icon :icon="['fas', 'user-lock']" size="lg"/>
                  </div>
                  <div class="header-elements">
                    <h6 class="title">
                      Login Information
                    </h6>
                  </div>
                </div>
              </template>
              <template #es-form>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="emailUserLabel">Email Address (User Name)</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input is-static"
                          type="text"
                          v-model="user.email"
                          id="emailUserLabel"
                          readonly/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" :class="{ removeUnderline: isEditGeneral }">
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="lastLogInLabel">Last Log In</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input class="input is-static"
                          type="text"
                          :value="user.lastAccessedDate | formatDateMMDDYYYYHHMM"
                          id="lastLogInLabel"
                          readonly/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="row" :class="{ removeUnderline: isEditGeneral }">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="lastPassLabel">Last Password Change</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input class="input is-static"
                            type="text"
                            :value="user.passwordChangeDate | formatDateMMDDYYYYHHMM"
                            id="lastPassLabel"
                            readonly/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </es-form>
              <es-form v-if="isEditSecurity">
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'info-square']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Password Rules
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <div class="es-form">
                    <div class="columns">
                        <div class="column is-half">
                          <div class="removeUnderline has-text-left"
                          v-for="rule in activeRules"
                          v-bind:key="rule.property">
                          <label class="label">{{ rule.message}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </es-form>
              <es-form v-if="isEditSecurity">
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'ruler']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Reset Password
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <div class="row" :class="{ removeUnderline: isEditGeneral }">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="emailAddrLabel">Email Address</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input class="input"
                            type="text"
                            v-model="user.email"
                            id="emailAddrLabel"
                            disabled/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" :class="{ removeUnderline: isEditGeneral }">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="cpLabel">Current Password</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input type="password" autocomplete="current-password"
                            class="input"
                            :class="{ 'is-static': !isEditSecurity,
                            'is-danger' : hasErrorPassword && msgPassword !==''}"
                            v-model="password"
                            v-if="isEditSecurity"
                            id="cpLabel">
                          </div>
                          <p v-if="hasErrorPassword" class="help is-danger">{{ msgPassword }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" :class="{ removeUnderline: isEditGeneral }">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="npLabel">New Password</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input type="password" autocomplete="new-password"
                            class="input"
                            :class="{ 'is-static': !isEditSecurity,
                            'is-danger' : hasErrorPassword && msgNewPassword !==''}"
                            v-model="newpassword"
                            v-if="isEditSecurity"
                            id="npLabel">
                          </div>
                          <p v-if="hasErrorPassword && msgNewPassword !=='' "
                          class="help is-danger">{{ msgNewPassword }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" :class="{ removeUnderline: isEditGeneral }">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label" for="renpLabel">Re-Enter New Password</label>
                      </div>
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <input type="password" autocomplete="new-password"
                            class="input"
                            :class="{ 'is-static': !isEditSecurity,
                            'is-danger' : hasErrorPassword && msgVerifyPassword !==''}"
                            v-model="verifypassword"
                            v-if="isEditSecurity"
                            id="renpLabel">
                          </div>
                          <p v-if="hasErrorPassword && msgVerifyPassword !=='' "
                          class="help is-danger">{{ msgVerifyPassword }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </es-form>
              <div class="es-actions" v-if="isEditSecurity">
                <es-form-actions>
                  <template #form-actions>
                    <div class="bottom-content">
                      <ul>
                        <li>
                          <div class="list-content">
                            <a tabindex="0" role="button"
                              @click.prevent="clearAll('security')"
                              @keypress.enter.prevent="clearAll('security')"
                            >
                              Cancel
                            </a>
                          </div>
                        </li>
                        <li>
                          <div class="list-content">
                            <button
                              class="button is-primary"
                              @click.prevent="verifyForm('security')">
                              Update
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </es-form-actions>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressBook,
  faAngleDown,
  faBan,
  faCheck,
  faEdit,
  faEnvelope,
  faIdCard,
  faInfoSquare,
  faMapMarkedAlt,
  faPhone,
  faRuler,
  faTrashAlt,
  faSearch,
  faUser,
  faUserLock,
  faPlus,
  faUserFriends,
  faDoorOpen,
} from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import UserEditAuthorization from '@/components/UserEditAuthorization.vue';
import UserAddAuthorization from '@/components/UserAddAuthorization.vue';
import UserRemoveAuthorizationModal from '@/components/UserRemoveAuthorizationModal.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PhoneUtils from '@/mixins/PhoneUtils';
import PasswordUtils from '@/mixins/PasswordUtils';
import DateUtils from '@/mixins/DateUtils';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import ZipUtils from '@/mixins/ZipUtils';
import FieldLabels from '@/mixins/FieldLabels';
import EsSelect from '@/components/EsSelect.vue';

library.add(
  faAddressBook,
  faAngleDown,
  faBan,
  faCheck,
  faEdit,
  faEnvelope,
  faIdCard,
  faInfoSquare,
  faMapMarkedAlt,
  faPhone,
  faRuler,
  faSearch,
  faTrashAlt,
  faUserLock,
  faUser,
  faPlus,
  faUserFriends,
  faDoorOpen,
);

export default {
  mixins: [
    BreadcrumbsManager,
    PhoneUtils,
    PasswordUtils,
    DateUtils,
    NotificationManager,
    PermissionManager,
    ZipUtils,
    FieldLabels,
  ],
  components: {
    EsProfileHeader,
    EsHeader,
    EsLoader,
    UserEditAuthorization,
    UserAddAuthorization,
    UserRemoveAuthorizationModal,
    EsForm,
    EsFormActions,
    EsSelect,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loadingPage: false,
      loadingError: null,
      apiMsg: '',
      messages: [],
      hasErrorFirstName: false,
      hasErrorMiddleName: false,
      hasErrorLastName: false,
      hasErrorDateOfBirth: false,
      hasErrorGender: false,
      hasErrorPhone1: false,
      hasErrorPhone2: false,
      hasErrorStreet1: false,
      hasErrorStreet2: false,
      hasErrorCity: false,
      hasErrorZip: false,
      hasErrorPassword: false,

      user: '',
      userBeforeEdit: '',
      userMaster: '',

      currentEditPanel: '',
      isEditGeneral: false,
      isEditSecurity: false,
      isAddAuthorization: false,
      isEditAuthorization: false,
      isEditPersonTypes: false,
      currentSection: 'general',
      locationPermissions: [],
      showModal: false,
      roleId: '',
      role: '',
      msgFirstName: '',
      msgLastName: '',
      msgMiddleName: '',
      msgDateOfBirth: '',
      msgGender: '',
      msgPhone1: '',
      msgPhone2: '',
      msgStreet1: '',
      msgStreet2: '',
      msgCity: '',
      msgZip: '',
      msgPassword: '',
      msgNewPassword: '',
      msgVerifyPassword: '',

      password: null,
      newpassword: null,
      verifypassword: null,

      roles: [],
      dateOfBirthYYYYMMDD: '',
      lastUpdateDateYYYYMMDD: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',

      apiQueryParams: { active: 'true' },
      hasErrorPersonType: false,
      msgPersonType: '',
      programs: [],
      // selectedPersonTypes: [{ name: 'Staff', personTypeCode: '02' }],
    };
  },
  watch: {
    $route() {
      this.onLoad();
      this.isEditAuthorization = false;
      this.isAddAuthorization = false;
    },
  },
  created() {
    this.setBreadcrumb([
      { text: 'Security Manager', to: {} },
    ]);
    this.onLoad();
  },
  methods: {
    ...mapActions([
      'getProfile',
      'getLocationPermissions',
      'getRoles',
      'updateUser',
      'updateUserPw',
      'forceResetPassword',
      'updateUserPT',
    ]),
    ...mapActions('lookups', [
      'loadStates',
      'loadTitles',
      'loadGenders',
      'loadPersonTypes',
      'loadPrograms',
    ]),
    async verifyForm(panel) {
      if (panel === 'security') {
        if (this.checkSecurityForm()) return;
        const cred = { currentPassword: this.password, newPassword: this.newpassword };
        try {
          await this.updateUserPw(cred);
          this.showSuccess('The user password has been updated successfully.');
          this.editPanel('');
          this.password = '';
          this.newpassword = '';
          this.verifypassword = '';
        } catch (error) {
          if (error.response.status === 500) {
            this.apiMsg = 'Network Error';
          } else if (error.response.status === 400) {
            this.apiMsg = this.formErrorMsg;
            const { message } = error.response.data;
            if (message === 'invalid username or password') {
              this.msgPassword = 'Password is invalid';
            } else if (message.includes('Password is invalid')) {
              this.msgNewPassword = message;
            }
            this.apiMsg = this.formErrorMsg;
            this.hasErrorPassword = true;
          } else {
            this.apiMsg = `${error.response.data.message}`;
          }
          this.showError(this.apiMsg);
        }
        return;
      }
      if (panel === 'persontypes') {
        if (this.checkPersonTypesForm()) return;
        try {
          await this.updateUserPT(this.user);
          this.showSuccess('The Person Type has been updated successfully.');
          this.userBeforeEdit = Object.assign({}, this.user);
          this.editPanel('');
          this.onLoad();
        } catch (error) {
          if (error.response.status === 500) {
            this.apiMsg = 'Network Error';
          } else if (error.response.status === 400) {
            this.apiMsg = this.formErrorMsg;
            this.hasErrorPassword = true;
          } else {
            this.apiMsg = `${error.response.data.message}`;
          }
          this.showError(this.apiMsg);
        }
        this.currentEditPanel = '';
        return;
      }
      if (panel === 'general') {
        if (this.checkGeneralForm()) return;
        this.user.phone1 = this.unmaskPhone(this.user.phone1);
        this.user.phone2 = this.unmaskPhone(this.user.phone2);
        this.trimFields();
      }
      try {
        await this.updateUser({ user: this.user, id: this.userMaster.id });
        this.showSuccess('The user profile has been updated successfully.');
        this.userBeforeEdit = Object.assign({}, this.user);
        this.editPanel('');
        this.onLoad();
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      }
      this.currentEditPanel = '';
    },
    async reloadAuthorizationPanel(operation) {
      this.fetchUserAuthorization();
      if (operation === 'edit') {
        this.isEditAuthorization = false;
      } else if (operation === 'add') {
        this.isAddAuthorization = false;
      } else if (operation === 'delete') {
        this.toggleModal();
        this.isEditAuthorization = false;
      }
      this.editPanel('');
    },
    async onLoad() {
      try {
        this.loadingPage = true;
        const responses = await Promise.all([
          this.getRoles(),
          this.loadPersonTypes(),
          this.loadPrograms(),
          this.loadStates(),
          this.loadTitles(),
          this.loadGenders(),
        ]);
        this.roles = responses[0].data;
        this.programs = this.activePrograms;
        const profileResponse = await this.getProfile(this.id);
        this.initialize(profileResponse.data);
        const res = await this.getLocationPermissions(this.id);
        this.locationPermissions = res.data;
      } catch (error) {
        this.loadingError = true;
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showError(this.apiMsg);
      } finally {
        this.setBreadcrumbs();
        this.loadingPage = false;
      }
    },
    async fetchUserAuthorization() {
      try {
        this.loading = true;
        const res = await this.getLocationPermissions(this.id);
        this.locationPermissions = res.data;
      } catch (error) {
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showError(this.apiMsg);
      } finally {
        this.loading = false;
      }
    },
    setBreadcrumbs() {
      if (this.activeModule.name === 'locationID') {
        this.setBreadcrumb([
          { text: 'Security Manager', to: { name: 'LISecurityManager' } },
          { text: ':userName', to: {} },
        ]);
      } else if (this.activeModule.name === 'directMatch') {
        this.setBreadcrumb([
          { text: 'Security Manager', to: { name: 'DMSecurityManager' } },
          { text: ':userName', to: {} },
        ]);
      } else if (this.activeModule.name === 'personId') {
        this.setBreadcrumb([
          { text: 'Security Manager', to: { name: 'PidSecurityManager' } },
          { text: ':userName', to: {} },
        ]);
      }
      this.replaceBreadcrumb({
        find: ':userName',
        replace: { text: `${this.user.firstName} ${this.user.lastName}`, to: {} },
      });
    },
    initialize(data) {
      this.userMaster = this.setDefaults(data);
      this.userBeforeEdit = JSON.parse(JSON.stringify(this.userMaster));
      this.user = JSON.parse(JSON.stringify(this.userMaster));
    },
    setDefaults(user) {
      const u = user;
      if (!user.middleName) u.middleName = '';
      if (!user.phone1) u.phone1 = '';
      if (!user.phone2) u.phone2 = '';
      if (!user.street1) u.street1 = '';
      if (!user.street2) u.street2 = '';
      if (!user.city) u.city = '';
      if (!user.zip) u.zip = '';
      if (user.dateOfBirth) {
        this.dateOfBirthYYYYMMDD = moment(user.dateOfBirth).format('YYYY-MM-DD');
      }
      if (!user.state) { u.state = { code: '', description: '' }; }
      if (!user.jobClassification) { u.jobClassification = { code: '', description: '' }; }
      if (!user.gender) { u.gender = { code: '', description: '' }; }
      return u;
    },
    async resetPassword() {
      try {
        await this.forceResetPassword(this.id);
        this.showSuccess('Reset Password is done.');
      } catch (error) {
        this.showError(error.response.data.message);
      }
    },
    resetSecurityForm() {
      this.password = '';
      this.newpassword = '';
      this.verifypassword = '';
    },
    resetFormErrors() {
      this.hasErrorFirstName = false;
      this.hasErrorMiddleName = false;
      this.hasErrorLastName = false;
      this.hasErrorDateOfBirth = false;
      this.hasErrorGender = false;
      this.hasErrorPhone1 = false;
      this.hasErrorPhone2 = false;
      this.hasErrorStreet1 = false;
      this.hasErrorStreet2 = false;
      this.hasErrorCity = false;
      this.hasErrorZip = false;
      this.hasErrorPassword = false;
      this.hasErrorPersonType = false;

      this.msgFirstName = '';
      this.msgMiddleName = '';
      this.msgLastName = '';
      this.msgDateOfBirth = '';
      this.msgGender = '';
      this.msgPhone1 = '';
      this.msgPhone2 = '';
      this.msgStreet1 = '';
      this.msgStreet2 = '';
      this.msgCity = '';
      this.msgZip = '';

      this.msgPassword = '';
      this.msgNewPassword = '';
      this.msgVerifyPassword = '';
      this.msgPersonType = '';
    },
    toggleModal(value) {
      if (value) {
        this.showModal = true;
        this.roleId = value;
      } else {
        this.showModal = false;
        this.roleId = '';
      }
    },
    editPanel(panel) {
      if (panel === 'general') {
        this.isEditGeneral = true;
        this.currentEditPanel = 'general';
        this.hideNotification();
      } else if (panel === 'editAuthorization') {
        this.isEditAuthorization = !this.isEditAuthorization;
        this.currentEditPanel = 'editAuthorization';
        this.hideNotification();
      } else if (panel === 'addAuthorization') {
        this.isAddAuthorization = true;
        this.currentEditPanel = 'addAuthorization';
        this.hideNotification();
      } else if (panel === 'security') {
        this.isEditSecurity = true;
        this.currentEditPanel = 'security';
        this.hideNotification();
      } else if (panel === 'persontypes') {
        this.isEditPersonTypes = true;
        this.currentEditPanel = 'persontypes';
        this.hideNotification();
      } else {
        this.isEditGeneral = false;
        this.isEditAuthorization = false;
        this.isAddAuthorization = false;
        this.isEditSecurity = false;
        this.isEditPersonTypes = false;
        this.currentEditPanel = '';
      }
    },
    undoForm(section) {
      if (section === 'general') {
        this.user = JSON.parse(JSON.stringify(this.userMaster));
      } else if (section === 'security') {
        this.resetSecurityForm();
      } else if (section === 'persontypes') {
        this.user = JSON.parse(JSON.stringify(this.userMaster));
      }
    },
    clearAll(section) {
      this.resetFormErrors();
      this.hideNotification();
      this.currentEditPanel = '';
      if (section === 'general') {
        this.undoForm(section);
        this.isEditGeneral = false;
      } else if (section === 'editAuthorization') {
        this.isEditAuthorization = false;
      } else if (section === 'addAuthorization') {
        this.isAddAuthorization = false;
      } else if (section === 'security') {
        this.undoForm(section);
        this.isEditSecurity = false;
      } else if (section === 'persontypes') {
        this.undoForm(section);
        this.isEditPersonTypes = false;
      } else {
        this.isEditGeneral = false;
        this.isEditAuthorization = false;
        this.isAddAuthorization = false;
        this.isEditSecurity = false;
        this.isEditPersonTypes = false;
      }
    },
    validateField(field) {
      if (field === 'firstName') {
        if (this.user.firstName === '') {
          this.hasErrorFirstName = true;
          this.msgFirstName = 'First Name is required.';
        } else if (this.user.firstName.length > 60) {
          this.hasErrorFirstName = true;
          this.msgFirstName = 'First Name allows a maximum of 60 characters.';
        } else {
          this.hasErrorFirstName = false;
          this.msgFirstName = '';
        }
      }
      if (field === 'middleName') {
        if (this.user.middleName && this.user.middleName.length > 60) {
          this.hasErrorMiddleName = true;
          this.msgMiddleName = 'Middle Name allows a maximum of 60 characters.';
        } else {
          this.user.middleName = this.user.middleName ? this.user.middleName : null;
          this.hasErrorMiddleName = false;
          this.msgMiddleName = '';
        }
      }
      if (field === 'lastName') {
        if (this.user.lastName === '') {
          this.hasErrorLastName = true;
          this.msgLastName = 'Last Name is required.';
        } else if (this.user.lastName && this.user.lastName.length > 60) {
          this.hasErrorLastName = true;
          this.msgLastName = 'Last Name allows a maximum of 60 characters.';
        } else {
          this.hasErrorLastName = false;
          this.msgLastName = '';
        }
      }
      if (field === 'gender') {
        if (this.user.gender.code) {
          const found = this.activeGenders.filter(s => s.code === this.user.gender.code);
          if (found) {
            this.user.gender.description = found[0].description;
            this.user.gender.code = found[0].code;
            this.user.genderCode = this.user.gender.code;
          }
        } else {
          this.user.gender = { code: '', description: '' };
          this.user.genderCode = null;
        }
      }
      if (field === 'street1') {
        if (this.user.street1 && this.user.street1.length > 128) {
          this.hasErrorStreet1 = true;
          this.msgStreet1 = 'Address1 allows a maximum of 128 characters.';
        } else {
          this.user.street1 = this.user.street1 ? this.user.street1 : null;
          this.hasErrorStreet1 = false;
          this.msgStreet1 = '';
        }
      }
      if (field === 'street2') {
        if (this.user.street2 && this.user.street2.length > 128) {
          this.hasErrorStreet2 = true;
          this.msgStreet2 = 'Address2 allows a maximum of 128 characters.';
        } else {
          this.user.street2 = this.user.street2 ? this.user.street2 : null;
          this.hasErrorStreet2 = false;
          this.msgStreet2 = '';
        }
      }
      if (field === 'city') {
        if (this.user.city && this.user.city.length > 25) {
          this.hasErrorCity = true;
          this.msgCity = 'City allows a maximum of 25 characters.';
        } else {
          this.user.city = this.user.city ? this.user.city : null;
          this.hasErrorCity = false;
          this.msgCity = '';
        }
      }
    },
    lookupOptional(field) {
      if (field === 'title') {
        if (this.user.jobClassification.code) {
          const title = this.activeTitles.filter(t => t.code === this.user.jobClassification.code);
          if (title) {
            this.user.jobClassification.description = title[0].description;
            this.user.jobClassification.code = title[0].code;
            this.user.jobClassificationCode = this.user.jobClassification.code;
          }
        } else {
          this.user.jobClassification = { code: '', description: '' };
          this.user.jobClassificationCode = null;
        }
      }
      if (field === 'state') {
        if (this.user.state.code) {
          const state = this.activeStates.filter(s => s.code === this.user.state.code);
          if (state) {
            this.user.state.description = state[0].description;
            this.user.state.code = state[0].code;
            this.user.stateCode = this.user.state.code;
          }
        } else {
          this.user.state = { code: '', description: '' };
          this.user.stateCode = null;
        }
      }
    },
    checkFormat(field) {
      switch (field) {
        case 'dateOfBirth':
          if (this.dateOfBirthYYYYMMDD !== ''
            && (!this.isValidDateFormat(this.dateOfBirthYYYYMMDD, 'YYYY-MM-DD')
            || !this.isValidDOB(this.dateOfBirthYYYYMMDD, 'YYYY-MM-DD'))) {
            this.hasErrorDateOfBirth = true;
            this.msgDateOfBirth = 'Date Of Birth is invalid.';
          } else {
            this.user.dateOfBirth = this.dateOfBirthYYYYMMDD || null;
            this.hasErrorDateOfBirth = false;
            this.msgDateOfBirth = '';
          }
          break;

        case 'phone1':
          if (!this.user.phone1) {
            this.hasErrorPhone1 = false;
            this.msgPhone1 = '';
          } else if (!this.isValidPhone(this.user.phone1)) {
            this.hasErrorPhone1 = true;
            this.msgPhone1 = 'Phone number is invalid.';
          } else {
            this.user.phone1 = this.user.phone1.trim() || null;
            this.hasErrorPhone1 = false;
            this.msgPhone1 = '';
          }
          break;

        case 'phone2':
          if (!this.user.phone2) {
            this.hasErrorPhone2 = false;
            this.msgPhone2 = '';
          } else if (!this.isValidPhone(this.user.phone2)) {
            this.hasErrorPhone2 = true;
            this.msgPhone2 = 'Phone number is invalid.';
          } else {
            this.user.phone2 = this.user.phone2.trim() || null;
            this.hasErrorPhone2 = false;
            this.msgPhone2 = '';
          }
          break;

        case 'zip':
          if (this.user.zip && this.user.zip.trim().length > 10) {
            this.hasErrorZip = true;
            this.msgZip = ' Zip allows a maximum of 10 characters.';
          } else if (!this.isValidZip(this.user.zip)) {
            this.hasErrorZip = true;
            this.msgZip = 'Zip is invalid.';
          } else {
            this.user.zip = this.user.zip ? this.user.zip.trim() : null;
            this.hasErrorZip = false;
            this.msgZip = '';
          }
          break;

        case 'gender':
          if (this.user.gender && this.user.gender.code !== '') {
            const found = this.activeGenders.find(s => s.code === this.user.gender.code);
            if (found) {
              this.user.gender = { code: found.code, description: found.description };
            }
          } else {
            delete this.user.gender;
          }
          break;

        default:
          console.warn(`Unexpected field: ${field}`);
          break;
      }
    },
    checkGeneralForm() {
      this.validateField('firstName');
      this.validateField('lastName');
      this.checkFormat('dateOfBirth');
      this.validateField('gender');
      this.validateField('middleName');
      this.validateField('street1');
      this.validateField('street2');
      this.validateField('city');
      this.lookupOptional('title');
      this.lookupOptional('state');
      this.checkFormat('phone1');
      this.checkFormat('phone2');
      this.checkFormat('zip');
      this.checkFormat('gender');
      const err = this.hasErrorLastName
      || this.hasErrorFirstName
      || this.hasErrorMiddleName
      || this.hasErrorDateOfBirth
      || this.hasErrorGender
      || this.hasErrorPhone1
      || this.hasErrorPhone2
      || this.hasErrorStreet1
      || this.hasErrorStreet2
      || this.hasErrorCity
      || this.hasErrorZip;
      if (err === true) {
        this.showError(this.formErrorMsg);
      }
      return err;
    },
    checkSecurityForm() {
      this.resetFormErrors();
      let error = 0;
      if (!this.password) {
        this.hasErrorPassword = true;
        this.msgPassword = 'Password is required';
        error += 1;
      } else if (!this.newpassword) {
        this.hasErrorPassword = true;
        this.msgNewPassword = 'Password is required';
        error += 1;
      } else if (!this.verifypassword) {
        this.hasErrorPassword = true;
        this.msgVerifyPassword = 'Password is required';
        error += 1;
      } else if (this.password === this.newpassword) {
        this.hasErrorPassword = true;
        this.msgNewPassword = 'Password must not be the same as the last password';
        error += 1;
      } else if (this.newpassword !== this.verifypassword) {
        this.hasErrorPassword = true;
        this.msgVerifyPassword = 'Passwords do not match';
        error += 1;
      } else {
        const failedpw = this.rulesFailed(this.user.email, this.password);
        if (failedpw.length > 0) {
          this.msgPassword = 'Password is invalid.';
          // failedpw.forEach((item) => { this.failedMsg += ` ${item}`; });
          this.hasErrorPassword = true;
          error += 1;
        } else {
          const failednpw = this.rulesFailed(this.user.email, this.newpassword);
          if (failednpw.length > 0) {
            this.msgNewPassword = 'Password is invalid.';
            // failednpw.forEach((item) => { this.failedMsg += ` ${item}`; });
            this.hasErrorPassword = true;
            error += 1;
          }
        }
      }
      if (error > 0) {
        this.showError(this.formErrorMsg);
      }
      return this.hasErrorPassword;
    },
    checkPersonTypesForm() {
      this.resetFormErrors();
      if (!this.user.userPersonTypes || !this.user.userPersonTypes.length) {
        this.hasErrorPersonType = true;
        this.msgPersonType = 'Person Type is required';
        this.showError(this.formErrorMsg);
        return true;
      }
      return false;
    },
    parseBadRequestErrors(data) {
      const messages = data.split(',');
      const errors = messages.map((item) => {
        const e = { field: item.trim().split(' ')[0], error: item.trim() };
        return e;
      });
      errors.forEach((e) => {
        if (e.field === 'first') {
          this.hasErrorFirstName = true;
          this.msgFirstName += e.error;
        } else if (e.field === 'middle') {
          this.hasErrorMiddleName = true;
          this.msgMiddleName += e.error;
        } else if (e.field === 'last') {
          this.hasErrorLastName = true;
          this.msgLastName += e.error;
        } else if (e.field === 'dateOfBirth') {
          this.hasErrorDateOfBirth = true;
          this.msgDateOfBirth += e.error;
        } else if (e.field === 'gender') {
          this.hasErrorGender = true;
          this.msgGender += e.error;
        } else if (e.field === 'phone1') {
          this.hasErrorPhone1 = true;
          this.msgPhone1 += e.error;
        } else if (e.field === 'phone2') {
          this.hasErrorPhone2 = true;
          this.msgPhone2 += e.error;
        } else if (e.field === 'street1') {
          this.hasErrorStreet1 = true;
          this.msgStreet1 += e.error;
        } else if (e.field === 'street2') {
          this.hasErrorStreet2 = true;
          this.msgStreet2 += e.error;
        } else if (e.field === 'city') {
          this.hasErrorCity = true;
          this.msgCity += e.error;
        } else if (e.field === 'zip') {
          this.hasErrorZip = true;
          this.msgZip += e.error;
        }
      });
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    showSuccess(error) {
      this.showNotification('success', [error]);
    },
    trimFields() {
      Object.keys(this.user).forEach((k) => {
        if (typeof this.user[k] === 'string' && this.user[k]) {
          this.user[k] = this.user[k].trim();
        }
      });
    },
  },
  computed: {
    ...mapGetters(['userPersonTypes']),
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      isStateUser: 'isStateUser',
    }),
    ...mapGetters('lookups', [
      'activeStates',
      'activeTitles',
      'activeGenders',
      'activePrograms',
    ]),
    adminMode() {
      return this.id !== this.$store.state.user.id;
    },
    securityMode() {
      const mode = parseInt(this.$store.state.user.id, 10) === parseInt(this.$route.params.id, 10);
      return mode;
    },
    primaryRole() {
      return this.locationPermissions.length <= 1;
    },
    isCurrentUser() {
      return this.$store.state.user.id === Number(this.id);
    },
    selectedPersonTypes() {
      return this.user.userPersonTypes.map(p => p.personType);
    },
    filterProgramsByPersonType() {
      const selectedPersonTypeCodes = [...this.selectedPersonTypes.map(type => type.code), '00'];
      return this.programs.filter(program => selectedPersonTypeCodes
        .includes(program.personTypeCode));
    },
  },
  filters: {
    formatDateMMDDYYYY(value) {
      if (value) {
        return moment(value).format('MM/DD/YYYY');
      }
      return 'N/A';
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 928px
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  .invalid-feedback
    font-style: italic
    color: #dc3545
    font-size: .7rem
    padding: .25rem 0 .25rem .15rem
  .edit-link
    color: #5953A4
    text-decoration: none
    background-color: transparent
    font-size: .75rem
    font-weight: 400
  .header-container
    display: flex
    margin-left: -1rem
  .header-elements
    margin-right: 1rem
    display: table-cell
    svg
      width: 30px
  .header-actions
    margin-left: auto
  .no-bottom-border
    border-bottom: none
</style>
